import { render, staticRenderFns } from "./PaymentRemarkListAddNew.vue?vue&type=template&id=de66bbd6&"
import script from "./PaymentRemarkListAddNew.vue?vue&type=script&lang=js&"
export * from "./PaymentRemarkListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRemarkListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports